import { SET_BIDS_PAYMENT_TYPE_TEXT_VALUE } from "../action";

export function setBidsPaymentTypeTextValue(textKey, textValue, bidNum) {
  return (dispatch) => {
    dispatch({
      type: SET_BIDS_PAYMENT_TYPE_TEXT_VALUE,
      payload: { textKey, textValue, bidNum },
    });
  };
}
